import { find, get, isEmpty, isNil } from "lodash";

const DUMMY_ICON = "https://icon-library.com/images/icon-url/icon-url-15.jpg";

const formatCost = (value) =>
  Number(value || 0).toLocaleString("fr-FR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const renderCard = ({
  icon,
  name,
  cost,
  upsellLines,
  addLinks,
  buttonLabel,
}) => `<div
        style="
        padding: 12px 24px;
        border: 1px solid #e7e7e7;
        border-radius: 16px;
        font-family: 'Nunito', sans-serif;background:#fff
        "
    >
        <table style="font-family: 'Nunito', sans-serif">
        <tr style="font-family: 'Nunito', sans-serif">
            <td style="width: 110px; max-height: 100px; font-family: 'Nunito', sans-serif">
                <img width="110"
                    src="${isNil(icon) ? DUMMY_ICON : icon}"
                    alt="${name}" width="110" style="font-family: 'Nunito', sans-serif; width: 110px; height: auto; max-width: 110px; max-height: 60px; display: block; border: 0; line-height: 0; text-decoration: none;" />
            </td>
            <td
            style="padding: 0 16px; width: 40%; font-family: 'Nunito', sans-serif"
            >
            <div style="margin: 0; font-family: 'Nunito', sans-serif">
                <p
                style="
                    font-size: clamp(12px, 3vw, 16px);
                    font-weight: 600;
                    margin:0 0 14px 0;
                    color: #272c49;
                    font-family: 'Nunito', sans-serif;
                "
                >
                ${name}
                </p>
                <div style="font-family: 'Nunito', sans-serif">
                <span
                    style="
                    font-family: 'Inter', sans-serif;
                    font-size: 32px;
                    font-weight: 900;
                    display: inline;
                    color: #272c49;
                    "
                    >${formatCost(cost)}</span
                >
                <span
                    style="
                    font-family: 'Inter', sans-serif;
                    font-size: 32px;
                    font-weight: 900;
                    display: inline;
                    color: #272c49;
                    "
                >
                    <span
                    style="
                        font-family: 'Inter', sans-serif;
                        font-size: 16px;
                        font-weight: 600;
                        display: inline;
                        color: #272c49;
                    "
                    >€</span
                    >
                    <span
                    style="
                        font-family: 'Inter', sans-serif;
                        font-size: 12px;
                        font-weight: 400;
                        display: inline;
                        color: #ff4b33;
                    "
                    >/mois</span
                    >
                </span>
                </div>
                <span
                style="
                    font-size: 12px;
                    color: #616970;
                    font-family: 'Nunito', sans-serif;
                "
                >
                ${(cost * 12).toFixed()} €/an
                <small
                    style="
                    font-size: 12px;
                    font-weight: 400;
                    color: #616970;
                    font-family: 'Nunito', sans-serif;
                    "
                    >tous frais inclus</small
                >
                </span>
            </div>
            <div>${upsellLines}</div>
            </td>
            ${addLinks
    ? `<td style="width: 40%; font-family: 'Nunito', sans-serif; vertical-align: middle; text-align: right;">
                <a href="#" style="color: #ffffff; font-family: 'Nunito', sans-serif; text-align: center; display: inline-block; padding: 16px 24px; background-color: #ff4b33; border: none; font-size: 16px; font-weight: 700; border-radius: 50px; text-decoration: none; box-sizing: border-box;">${buttonLabel}</a>
            </td>`
    : ""
  }
        </tr>
        </table>
    </div>
    <br/>`;

const buildCardBlockHtml = ({
  costs,
  upsells,
  combinations,
  addLinks,
  buttonLabel,
}) => {
  if (!costs?.length) return "";

  const cards = !isEmpty(combinations)
    ? combinations
      .map((combination) => {
        const baseCostEntry = find(
          costs,
          (entry) =>
            get(entry, "insurancePlan.id") ===
            combination.baseInsurancePlanId,
        );
        if (!baseCostEntry) return null;
        const baseInsurancePlan = get(baseCostEntry, "insurancePlan");
        const baseCost = get(baseCostEntry, "cost", 0);
        const complementModule = combination.complementaryInsurancePlanId
          ? find(
            get(upsells, combination.baseInsurancePlanId, []),
            (module) =>
              get(module, "insurancePlan.id") ===
              combination.complementaryInsurancePlanId,
          )
          : null;
        const complementName = get(complementModule, "insurancePlan.name");
        const complementCost = get(complementModule, "cost", 0);
        const totalCost = baseCost + complementCost;
        const cardName = complementName
          ? `${get(baseInsurancePlan, "name")} avec ${complementName}`
          : get(baseInsurancePlan, "name");
        const upsellLines = complementModule
          ? `<div>${complementName} - ${formatCost(complementCost)} €/mois</div>`
          : "";
        return renderCard({
          icon: get(baseInsurancePlan, "icon"),
          name: cardName,
          cost: totalCost,
          upsellLines,
          addLinks,
          buttonLabel,
        });
      })
      .filter(Boolean)
    : costs.map(({ insurancePlan, cost }) => {
      const modules = get(upsells, get(insurancePlan, "id"), []);
      const upsellLines = modules
        .map(
          (module) =>
            `<div>${get(module, "insurancePlan.name")} - ${formatCost(
              get(module, "cost", 0),
            )} €/mois</div>`,
        )
        .join("");
      return renderCard({
        icon: get(insurancePlan, "icon"),
        name: get(insurancePlan, "name"),
        cost,
        upsellLines,
        addLinks,
        buttonLabel,
      });
    });

  return `<div>${cards.join("")}</div>`;
};

export default buildCardBlockHtml;
